export const createLesson = (params, body) => ({
  data: {
    lesson: {
      id: Math.floor(Math.random() * 200) + 1,
      ...body,
      chapter: { id: body.chapter },
    },
  },
  status: 200,
});

export const updateLesson = (params, body) => ({
  data: {
    lesson: {
      id: params.pk,
      ...body,
      chapter: { id: body.chapter },
    },
  },
  status: 200,
});

const types = [
  { id: 1, type: "video" },
  { id: 2, type: "document" },
  { id: 3, type: "quiz" },
];

export const changeType = (params, body) => {

  return {
    data: {
      lesson: {
        lesson_type: body.lesson_type,
        quiz: {
          id: 1,
          timing: 12,
          total_score: 100,
          questions: [
            {
              id: 1,
              content: "123",
              image_url: null,
              score: 10,
              order: 0,
              type: 'single',
              answers: [
                {
                  id: 1,
                  content: "answer1"
                },
                {
                  id: 2,
                  content: "answer2"
                },
                {
                  id: 3,
                  content: "answer3"
                }
              ]
            },
            {
              id: 2,
              content: "Hôm nay bạn thế nào?",
              image_url: null,
              score: 10,
              order: 1,
              type: 'single',
              answers: [
                {
                  id: 1,
                  content: "Vui"
                },
                {
                  id: 2,
                  content: "Buồn"
                },
                {
                  id: 3,
                  content: "Bình thường"
                }
              ]
            }
          ]
        },
      },
    },
    status: 200,
  };
};

export const saveLessonContent = (params, body) => ({
  data: {
    lesson: {
      video: {
        thumbnail_url: body.thumbnail_url,
        url: body.url,
        video_url:
          "https://player.vimeo.com/progressive_redirect/playback/700650493/rendition/360p?loc=external&oauth2_token_id=1588606044&signature=a0f82f6328bb804c42d24caa1a70d368cd2161b0c4c8cb280c939da676b4865d",
      },
    },
    status: 200,
  },
});

export const createVideoTimeline = (params, body) => ({
  data: {
    timeline: {
      id: Math.floor(Math.random() * 200) + 1,
      content: body.content,
      checkpoint: body.checkpoint,
    },
  },
  status: 200,
});
